var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.f03e08ccc13a8b29e8ef23fa148b764c.svg#n';
                    var viewUrl = 'sprites.f03e08ccc13a8b29e8ef23fa148b764c.svg#view-n';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 54 28',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };